import { signalStore, type } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';

import { BlocCompétences } from '../../croisement-référentiel/models/bloc-compétences';
import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { avecMéthodesBlocCompétences } from './bloc-compétences.methods';

export const configBlocCompétences = entityConfig({
  entity: type<BlocCompétences>(),
  selectId: (bloc) => bloc.codeBloc,
});

export const BlocCompétencesStore = signalStore(
  { providedIn: 'root' },
  withEntities<BlocCompétences>(configBlocCompétences),
  withSelectedEntity(),
  avecMéthodesBlocCompétences(),
);
